import { network } from 'services/network';

export const renameUserGroup = (params) => {
    const userGroupName = {
        customerId: params.customer_id,
        newName: params.newName,
        oldName: params.group_name,
    };
    return network.post('admin/bo/renameUserGroup', userGroupName).then((response) => response.data);
};
